import ImageDomain from '../domains/Image'
import ProductImage from '../domains/ProductImage'
import ProductMedia from '../domains/ProductMedia'
import ProductVideo from '../domains/ProductVideo'
import VideoDomain from '../domains/Video'

import type { Block, Inline, Text } from '@contentful/rich-text-types'

export const isTextNode = (node: Block | Inline | Text | undefined): node is Text => {
  if ((node as Text).value) {
    return true
  }
  return false
}

export const isProductImage = (el: ProductMedia): el is ProductImage => {
  if ((el as ProductImage).image) {
    return true
  }
  return false
}

export const isProductVideo = (el: ProductMedia): el is ProductVideo => {
  if ((el as ProductVideo).video) {
    return true
  }
  return false
}

export const isImage = (el: ImageDomain | VideoDomain): el is ImageDomain => {
  if (el as ImageDomain) {
    return true
  }
  return false
}

export const isVideo = (el: ImageDomain | VideoDomain): el is VideoDomain => {
  if (el as VideoDomain) {
    return true
  }
  return false
}

export const isHtmlDivElement = (el: Element): el is HTMLDivElement => {
  if (el && 'style' in el) {
    return true
  }
  return false
}

export const isEventTargetAHtmlDivElement = (et: EventTarget | null): et is HTMLDivElement => {
  if (et && 'getBoundingClientRect' in et) {
    return true
  }
  return false
}
